// UTM capture and forwarding helpers
// On any page load: capture utm_* params from URL → save to localStorage (24h sticky)
// Then `getStoredUtms()` returns the latest UTMs to forward to lead submissions + redirect tracker.

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
const STORAGE_KEY = "sg247_utms";
const TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

export function captureUtmsFromUrl() {
  if (typeof window === "undefined") return null;
  try {
    const url = new URL(window.location.href);
    const captured = {};
    UTM_KEYS.forEach((k) => {
      const v = url.searchParams.get(k);
      if (v) captured[k] = v;
    });
    if (Object.keys(captured).length > 0) {
      const payload = { utms: captured, captured_at: Date.now(), landing_path: url.pathname };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      return captured;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function getStoredUtms() {
  if (typeof window === "undefined") return {};
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (!parsed?.captured_at || Date.now() - parsed.captured_at > TTL_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return {};
    }
    return parsed.utms || {};
  } catch {
    return {};
  }
}

export function appendUtmsToUrl(url) {
  if (!url) return url;
  const utms = getStoredUtms();
  if (Object.keys(utms).length === 0) return url;
  try {
    const u = new URL(url, window.location.origin);
    Object.entries(utms).forEach(([k, v]) => {
      if (!u.searchParams.has(k)) u.searchParams.set(k, v);
    });
    return u.toString().replace(window.location.origin, "");
  } catch {
    // Relative URL — naive append
    const sep = url.includes("?") ? "&" : "?";
    const qs = Object.entries(utms)
      .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
      .join("&");
    return `${url}${sep}${qs}`;
  }
}

/**
 * Build a tracked affiliate URL.
 * Use `/api/r/{kind}/{slug}` so we log every click and forward UTMs.
 */
export function buildAffiliateUrl(kind, slug) {
  if (!slug) return "/best-betting-sites";
  return appendUtmsToUrl(`/api/r/${kind}/${slug}`);
}

// Auto-capture on import
captureUtmsFromUrl();
